import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

import {
  createCommissionRule,
  fetchCommissionRuleAll,
  fetchCommissionRuleById,
  updateCommissionRule,
  deleteCommissionRule,
  createCommissionRuleAssign,
  cancelCommissionRuleAssign,
  fetchCommissionRuleAssignList,
  getCommissionTransactionList,
  getCommissionChart
} from "@/services/commission.js";

@Module({
  namespaced: true
})
export default class Commission extends VuexModule {
  // state
  editCommissionRule = {};
  fetchCommissionRule = [];
  fetchCommissionRuleAssign = [];
  transactionsList = [];
  graphData = [];

  // Action
  @Action
  public async createCommissionRule(payload) {
    try {
      const data = await createCommissionRule(payload);
      return data.response;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async fetchCommissionRuleAction() {
    try {
      const data = await fetchCommissionRuleAll();
      this.context.commit("setFetchCommissionRule", data.response);
      return data.response;
    } catch (err) {
      throw err;
    }
  }

  @Action
  async deleteCommissionRuleAction(payload) {
    console.log(payload);
    try {
      const data = await deleteCommissionRule(payload);
      this.context.commit("deleteItem", payload);
      return data.response;
    } catch (e) {
      throw e;
    }
  }

  @Action
  public async editCommissionRuleAction(payload) {
    try {
      const data = await fetchCommissionRuleById(payload);
      this.context.commit("setEditCommissionRule", data.response);
      return data.response;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async updateCommissionRuleAction(payload) {
    try {
      const data = await updateCommissionRule(payload);
      return data.response;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async createCommissionRuleAssign(payload) {
    try {
      const data = await createCommissionRuleAssign(payload);
      return data.response;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async fetchCommissionRuleAssignList(id) {
    try {
      const data = await fetchCommissionRuleAssignList(id);
      this.context.commit("setCommissionRuleAssign", data.response);
      return data.response;
    } catch (err) {
      throw err;
    }
  }
  @Action
  public async cancelCommissionRuleAssign(payload) {
    try {
      const data = await cancelCommissionRuleAssign(payload);
      return data.response;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async getCommissionTransactionList(payload) {
    try {
      const data = await getCommissionTransactionList(payload);
      this.context.commit("setCommissionTransactions", data.response);
      return data.response;
    } catch (err) {
      throw err;
    }
  }

  @Action
  public async getCommissionChart(payload) {
    try {
      const data = await getCommissionChart(payload);
      this.context.commit("setCommissionChart", data.response);
      return data.response;
    } catch (err) {
      throw err;
    }
  }
  // Mutation

  @Mutation
  public setEditCommissionRule(data: any) {
    this.editCommissionRule = data;
  }

  @Mutation
  public setCommissionTransactions(data: any) {
    this.transactionsList = data;
  }

  @Mutation
  public setCommissionChart(data: any) {
    this.graphData = data;
  }

  @Mutation
  public setFetchCommissionRule(data: any) {
    this.fetchCommissionRule = data;
  }
  @Mutation
  public setCommissionRuleAssign(data: any) {
    this.fetchCommissionRuleAssign = data;
  }

  @Mutation
  deleteItem(itemId) {
    let items: any = this.fetchCommissionRule.map((i: any) => {
      if (i._id === itemId) {
        i.active = false;
      }
      return i;
    });
    this.fetchCommissionRule = items;
  }

  // getters

  get GetEditCommissionRule() {
    return this.editCommissionRule;
  }

  get GetFetchCommissionRule() {
    return this.fetchCommissionRule;
  }
  get GetCommissionRuleList() {
    return this.fetchCommissionRuleAssign;
  }

  get GetCommissionRuleTransactions() {
    return this.transactionsList;
  }

  get GetCommissionChart() {
    return this.graphData;
  }
}
